import { render, staticRenderFns } from "./CardReport.vue?vue&type=template&id=0f2be3b3&scoped=true&"
import script from "./CardReport.vue?vue&type=script&lang=js&"
export * from "./CardReport.vue?vue&type=script&lang=js&"
import style0 from "./CardReport.vue?vue&type=style&index=0&id=0f2be3b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2be3b3",
  null
  
)

export default component.exports